import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';
import { SCROLL_TRACKING } from '../config/analytics';

/**
 * Componente para tracking de scroll depth (profundidade de rolagem)
 * Monitora quanto da página o usuário visualizou
 */
const ScrollTracker = () => {
  const { trackScrollDepth } = useAnalytics();
  const location = useLocation();
  const trackedThresholds = useRef(new Set());
  const lastScrollTime = useRef(0);

  useEffect(() => {
    if (!SCROLL_TRACKING.ENABLED) return;

    const handleScroll = () => {
      const now = Date.now();
      
      // Debounce para evitar spam de eventos
      if (now - lastScrollTime.current < SCROLL_TRACKING.DEBOUNCE_TIME) {
        return;
      }
      
      lastScrollTime.current = now;

      // Calcular porcentagem de scroll
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercentage = Math.round((scrollTop / documentHeight) * 100);

      // Verificar se algum threshold foi atingido
      SCROLL_TRACKING.THRESHOLDS.forEach(threshold => {
        if (scrollPercentage >= threshold && !trackedThresholds.current.has(threshold)) {
          trackedThresholds.current.add(threshold);
          trackScrollDepth(threshold);
        }
      });
    };

    // Adicionar listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [trackScrollDepth]);

  // Reset quando a página muda
  useEffect(() => {
    trackedThresholds.current.clear();
  }, [location.pathname]);

  // Este componente não renderiza nada
  return null;
};

export default ScrollTracker;